const { isString } = require('../is-string')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} element
 * @returns {*}
 */
function getElement (element) {
  if (typeof window === 'undefined' || !element || !isString(element)) return

  let el = element

  if (
    !el.includes('#') &&
    !el.includes('.') &&
    !el.includes('[')
  ) {
    el = `#${el}`
  }

  return document.querySelector(el) || undefined
}

module.exports = { getElement }
